import React, { useEffect, useState } from 'react'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BurgerMenuTitle from '../../Component/BurgerMenuTitle/BurgerMenuTitle'
import Style from './ProductDetail.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faHeart} from "@fortawesome/free-solid-svg-icons";
import { getProductDetailApi, getProductDetailApiDependSupplier, postAddToFavoriteApi, postRemoveFavoriteApi} from '../../Api/ClientServices';
import PointSpreadLoading from 'react-loadingg/lib/PointSpreadLoading';
import SupermarketList from '../../Component/SupermarketList/SupermarketList'
import { errorToast, succToast } from '../../Toast/Toast';
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import 'swiper/swiper-bundle.css';
import { Pagination } from "swiper";
import './ProductDetail.css'
import MenuBottom from '../../Component/menuBottom/MenuBottom';

const ProductDetail = (props) => {
    const [detail , setDetail]=useState()
    const path = window.location.pathname.split("/");

    useEffect(()=>{
        if(path[3]===''){
        getDetails(1)
        }  
        else{
            getDetails(2,path[3])
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])  
    
    // const nl2br = require('react-nl2br');
    // const result = nl2br('aaa\nbbb\nccc\nddd')

    const Update=async()=>{
        getProductDetailApi(props.location.state,(succ,res)=>{
            if(succ){
              if(res.status===0){
                errorToast(res.message)
              }else{
                setDetail(res.product)
              }
            }else{
              console.error(res)
            }
          })
    }
    const getDetails=async(value,id)=>{
        if(value===1){
        Update()        
        }
        else{
            getProductDetailApiDependSupplier(path[2],id,(succ,res)=>{
                if(succ){
                  if(res.status===0){
                    errorToast(res.message)
                  }else{
                    setDetail(res.product)
                  }
                }else{
                  console.error(res)
                }
              })
        }
    }
    const goldStarHandler=()=>{

        let productId={
            id:path[2]
        }
        if(detail.favorite==='0'){
            postAddToFavoriteApi(productId,(res)=>{
                if(res.status===1){
                    succToast(res.message) 
                    getDetails(2,path[3])

                }
                else{
                    errorToast(res.message)
                } 
            }) 
        }
        else{
            postRemoveFavoriteApi(productId,(res)=>{
                if(res.status===1){
                    succToast(res.message) 
                    getDetails(2,path[3])
                }
                else{
                    errorToast(res.message)
                }
            })  
        }         
    }
    let loading=null
    if(detail===undefined){
        loading=<div className={Style.SetLoading}><PointSpreadLoading color={'#ab0c59'} size={"small"} /></div>
    }
    else{ 
        loading=
        <div className={Style.holder}>
            <BurgerMenuTitle title={detail.name}/>
            <div className={Style.center}> 
                <div className={Style.sliderHolder}>
                    <div onClick={goldStarHandler} className={Style.favorite}>
                        <FontAwesomeIcon icon={faHeart} className={detail.favorite==='1' ? Style.goldStar :Style.whiteStar } />
                    </div>
                    <Swiper pagination={{dynamicBullets: true,}} modules={[Pagination]} spaceBetween={20} style={{width:"20rem",height:"100%"}} dir="rtl">
                        {detail.image.map((item,index)=>{
                            return(
                            <SwiperSlide key={index} className={Style.picHolder}>
                                <img src={`//cdn.barest.ir/product/m/${item}.jpg`} alt="جزئیات محصول"/>
                            </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </div>
                <div className={Style.information}>
                    <h2 className={Style.productName}>{detail.name}</h2>
                    {detail.other_detail&&<h4 className={detail.other_detail===null ? Style.orderNull:Style.order}>
                        {detail.other_detail.split('n').map((item,index)=> {
                        return (<div key={index}>
                            {item}
                            <br />
                        </div>
                        )
                        })}
                    </h4>}
                    <div className={detail.brand_persian===undefined?Style.brandNone:Style.brandName}>
                        <span>برند:</span>
                        <h3 className={Style.brand}>{detail.brand_persian}</h3>
                    </div>
                    {(detail.weight===null && detail.volume===null)||(detail.weight==="0" && detail.volume==="0")?
                    null :
                        <div className={Style.weightHolder}>
                            <span>مقدار:</span>
                            {detail.weight==="0"?  
                            <h3 className={Style.brand}> {detail.volume} میلی لیتر </h3>
                            :
                            detail.weight>1000?
                            <h3 className={Style.brand}> {detail.weight/1000} کیلوگرم </h3>

                            :
                            <h3 className={Style.brand}> {detail.weight} گرم </h3>
                            }
                        </div>
                    }
                </div>
                <SupermarketList update={Update} data={detail} splice={false}/>
            </div>
        </div>
    }
    return (
        <div>
            {
            loading
            } 
            <MenuBottom/>
        </div>
        
    )
}
export default ProductDetail
